const per1k = (w) => w / 1000;

export const CALC = {
  books: {
    sizes: [{ key: "words", label: "Word count", def: 60000, max: 500000 }, { key: "covers", label: "Cover concepts", def: 4, max: 20 }],
    steps: [
      { key: "proof", label: "Proofread", on: true, qty: (s) => per1k(s.words) },
      { key: "rewrite", label: "Rewrite", on: false, qty: (s) => per1k(s.words) },
      { key: "narrate", label: "AI audiobook narration", on: false, qty: (s) => per1k(s.words) },
      { key: "cover", label: "Cover concepts", on: true, qty: (s) => s.covers },
    ],
  },
  comics: {
    sizes: [{ key: "pages", label: "Pages", def: 24, max: 500 }, { key: "ppp", label: "Panels per page", def: 5, max: 12 }, { key: "chars", label: "Main characters", def: 3, max: 30 }],
    steps: [
      { key: "script", label: "AI panel script", on: true, qty: (s) => s.pages * 0.2 },
      { key: "panel", label: "AI-drawn panels", on: true, qty: (s) => s.pages * s.ppp },
      { key: "sheet", label: "Character sheets", on: true, qty: (s) => s.chars },
      { key: "cover", label: "4 cover concepts", on: false, qty: () => 4 },
    ],
  },
  webtoons: {
    sizes: [{ key: "eps", label: "Episodes", def: 1, max: 200 }, { key: "ppe", label: "Panels per episode", def: 40, max: 150 }, { key: "chars", label: "Main characters", def: 3, max: 30 }],
    steps: [
      { key: "script", label: "AI panel script", on: true, qty: (s) => s.eps * 1.5 },
      { key: "panel", label: "AI-drawn panels", on: true, qty: (s) => s.eps * s.ppe },
      { key: "sheet", label: "Character sheets", on: false, qty: (s) => s.chars },
    ],
  },
  poetry: {
    sizes: [{ key: "poems", label: "Poems", def: 30, max: 1000 }, { key: "illus", label: "Illustrated poems", def: 10, max: 1000 }],
    steps: [
      { key: "polish", label: "AI polish", on: true, qty: (s) => s.poems },
      { key: "reading", label: "AI audio readings", on: true, qty: (s) => s.poems },
      { key: "illus", label: "Illustrations", on: true, qty: (s) => s.illus },
    ],
  },
};
CALC.manga = { ...CALC.comics, sizes: [{ key: "pages", label: "Pages", def: 20, max: 500 }, { key: "ppp", label: "Panels per page", def: 6, max: 12 }, { key: "chars", label: "Main characters", def: 4, max: 30 }] };

export const initState = (id) => {
  const m = CALC[id];
  return { sizes: Object.fromEntries(m.sizes.map((x) => [x.key, x.def])), steps: Object.fromEntries(m.steps.map((x) => [x.key, x.on])) };
};

export const calcTotal = (id, state, actions) => {
  const price = Object.fromEntries(actions.map((a) => [a.key, a.exact ?? a.credits]));
  return CALC[id].steps.reduce((t, st) => t + (state.steps[st.key] ? st.qty(state.sizes) * (price[st.key] || 0) : 0), 0);
};

export const suggestPack = (need, packs) => {
  if (need <= 0 || !packs.length) return null;
  const fit = [...packs].sort((a, b) => a.credits - b.credits).find((p) => p.credits >= need);
  if (fit) return { pack: fit, count: 1 };
  const big = packs.reduce((a, b) => (b.credits > a.credits ? b : a));
  return { pack: big, count: Math.ceil(need / big.credits) };
};
